import React from 'react';

import './job-co-partner.css';

export default function JobCoPartner(props) {

    return (
        <span className="Job-co-partner"> {props.name}</span>
    );
}